// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 918 ? "00d22bb0" : chunkId) + "." + {"767":"438c4806f59c7732","918":"a30d5818bbaee880"}[chunkId] + ".js";
};